import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { usePermissions, PermissionContext } from "./controllers/PermissionContext";

import LoginPage from "./components/LoginPage/LoginPage.js";
import ResetPassword from "./components/LoginPage/ResetPassword.js";
import Sidebar from "./components/SideBar/Sidebar.jsx";
import Dashboard from "./pages/DashBaord/Dashboard.jsx";
import SubAdminList from './pages/Accounts/SubAdmin/List.js'
import SubAdminAddEditData from './pages/Accounts/SubAdmin/AddEditData.js'
import { fetchIpAddress } from "./controllers/API"

import K_WinnInvoiceList from "./pages/v1/k_winn_invoice/List.js";
import K_WinnInvoiceAddEditData from "./pages/v1/k_winn_invoice/AddEditData.js";
import K_WinnInvoicePreview from "./pages/v1/k_winn_invoice/preview.js";
import K_WinnBulkList from './pages/v1/k_winn_invoice/bulk/List.js'
import K_WinnBulkRequest from './pages/v1/k_winn_invoice/bulk/CreateRequest.js'
import K_WinnRetailersList from './pages/v1/k_winn_invoice/bulk/RetailersList.js'
import K_WinnBulkInvoicePreview from './pages/v1/k_winn_invoice/bulk/BulkPreview.js'
import K_WinnDownloadAllInvoice from './pages/v1/k_winn_invoice/bulk/DownloadInvoice.jsx'
import Analyser from './pages/v1/analyser/list.js';
import GeneralData from './pages/v1/GeneralData/GeneralData.js';
import CustomerDue from "./pages/v1/customer_due/List.js";
import ActiveLog from "./pages/v1/activelogs/List.js";
import TransactionList from "./pages/v1/transactions/List.js";


const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const getIp = async () => {
    await fetchIpAddress();
  };
  const PERMISSION = usePermissions("FULL");
  const { refetchPermissions } = React.useContext(PermissionContext);
  // Update state initialization to restore from sessionStorage if available
  const [PERMISSIONDATA, setPermissionData] = useState(() => {
    const saved = sessionStorage.getItem("PERMISSIONDATA");
    return saved ? JSON.parse(saved) : '';
  });
    const getFullPermission = async () => {
      try {
        if (PERMISSION && PERMISSION?.fullAccess === 'N' && Object.keys(PERMISSION?.permissions || {}).length === 0) {
          getFullPermission();
          setPermissionData(PERMISSION?.permissions);
        } else{
          setPermissionData(PERMISSION?.permissions);
        }
      } catch (error) {
        
      }
    }
  // Add effect to update sessionStorage whenever PERMISSION changes
  useEffect(() => {
    if (PERMISSION?.permissions) {
      setPermissionData(PERMISSION.permissions);
      sessionStorage.setItem("PERMISSIONDATA", JSON.stringify(PERMISSION.permissions));
    }
  }, [PERMISSION]);
  useEffect(() => {
    const checkAuthentication = async () => {
      await getIp();
      const token = sessionStorage.getItem("TOKEN");

      if (!["/", "/login", "/reset-password","/invoice/preview"].includes(location?.pathname)) {
        if (!token) {
          navigate("/");
        } else {
          if(location?.pathname === "/dashboard"){
            refetchPermissions();
          }
          // fetchUserInfo();
        }
      }
    };
    // Update main effect to only call getFullPermission if no saved permissions
    const saved = sessionStorage.getItem("PERMISSIONDATA");
    if (saved) {
      setPermissionData(JSON.parse(saved));
    } else {
      getFullPermission();
    }
    checkAuthentication();
  }, [location, navigate]);
  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  return (
    <div className="App">
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={ <Sidebar> <Dashboard /> </Sidebar> } />
          {(user?.admin_type === 'Super Admin') && (<>
            <Route path="/sub-admin/list" element={ <Sidebar> <SubAdminList /> </Sidebar> } />
            <Route path="/active-logs" element={ <Sidebar> <ActiveLog /> </Sidebar> } />
          </>)}

          <Route path="/sub-admin/addeditdata" element={ <Sidebar> <SubAdminAddEditData /> </Sidebar> } />

          {/* K-Winn Invoice Routes */}
          {(PERMISSIONDATA?.invoice?.individual === 'Y' || user?.admin_type === 'Super Admin') && (<> 
            <Route path="/invoice/list" element={ <Sidebar> <K_WinnInvoiceList /> </Sidebar> } />
            <Route path="/invoice/addeditdata" element={ <Sidebar> <K_WinnInvoiceAddEditData /> </Sidebar> } />
          </>)}

          <Route path="/invoice/preview" element={ <K_WinnInvoicePreview /> } />
          <Route path="/invoice/bulk-preview/:batch_id" element={<K_WinnBulkInvoicePreview/>}/>
          {(PERMISSIONDATA?.invoice?.bulk_request === 'Y' || user?.admin_type === 'Super Admin') && (<> 
            <Route path="/invoice/request" element={<Sidebar><K_WinnBulkList/></Sidebar>} />
            <Route path="/invoice/create-request" element={<Sidebar><K_WinnBulkRequest/></Sidebar>} />
            <Route path="/invoice/retailers-list/:batch_id" element={<Sidebar><K_WinnRetailersList/></Sidebar>} />
            <Route path="/invoice/download-all" element={<Sidebar><K_WinnDownloadAllInvoice/></Sidebar>}/>
          </>)}

          {(PERMISSIONDATA?.customer_due?.customer_list === 'Y' || user?.admin_type === 'Super Admin') && (<> 
            <Route path="/customers-due/list" element={<Sidebar><CustomerDue/></Sidebar>} />
          </>)}

          <Route path="/analyser" element={<Sidebar><Analyser/></Sidebar>}/>
          <Route path="/transaction" element={<Sidebar><TransactionList/></Sidebar>}/>

            {(user?.admin_type === 'Super Admin') && (<>
              <Route path="/general-data" element={<Sidebar><GeneralData/></Sidebar>}/>
          </>)}



          {/* END */}
        </Routes>
      
    </div>
  );
};

export default App;
